import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Pencil, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';

const ProductList = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pendingDeleteId, setPendingDeleteId] = useState(null);
    const navigate = useNavigate();
    const token = localStorage.getItem('adminToken');

    const loadProducts = async () => {
        try {
            const res = await axios.get('/api/products');
            setProducts(res.data);
            setLoading(false);
        } catch (e) {
            console.error(e);
            toast.error('Ошибка загрузки товаров');
            setLoading(false);
        }
    };

    useEffect(() => {
        loadProducts();
    }, []);

    const handleDelete = async (id) => {
        try {
            await axios.delete(`/api/products/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setProducts(products.filter(p => p.id !== id));
            toast.success('Товар удален');
        } catch (err) {
            toast.error('Ошибка при удалении.');
        } finally {
            setPendingDeleteId(null);
        }
    };

    if (loading) return <div>Загрузка...</div>;

    return (
        <div className="admin-page">
            <h2>📦 Управление товарами</h2>
            
            <div className="admin-table-wrap">
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Название</th>
                            <th>Цена</th>
                            <th>Тип</th>
                            <th style={{width: '120px'}}>Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map(p => (
                            <tr key={p.id}>
                                <td>#{p.id}</td>
                                <td>{p.title}</td>
                                <td>{Math.floor(p.price).toLocaleString()} TJS</td>
                                <td><span className={`badge ${p.category}`}>{p.category.toUpperCase()}</span></td>
                                <td>
                                    <div className="action-buttons">
                                        <button onClick={() => navigate(`/admin/edit/${p.id}`)} className="btn-icon btn-edit" title="Редактировать">
                                            <Pencil size={18} />
                                        </button>
                                        <button onClick={() => setPendingDeleteId(p.id)} className="btn-icon btn-delete" title="Удалить">
                                            <Trash2 size={18} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {pendingDeleteId && (
                <div className="admin-modal-overlay">
                    <div className="admin-modal-box">
                        <h3>Удалить товар?</h3>
                        <p>Товар будет удалён без возможности восстановления.</p>
                        <div className="admin-modal-actions">
                            <button type="button" className="btn-cancel" onClick={() => setPendingDeleteId(null)}>
                                Отмена
                            </button>
                            <button type="button" className="btn-submit btn-danger" onClick={() => handleDelete(pendingDeleteId)}>
                                Удалить
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProductList;